import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import css from 'css';
import api from 'api';
import WP from 'WP';
import Container from 'partials/Container';
import DateFormater from 'partials/DateFormater';
import SmartLink from 'partials/SmartLink';
import { trunclate } from 'helpers';

class NewsAndLinks extends Component {

    constructor() {
        super();

        this.state = {
            news: []
        }
    }

    componentWillMount() {
        this.mounted = true;

        api.getNews({ limit: 3 })
            .then(resp => {
                //console.log(resp.data);
                if(this.mounted) this.setState({ news: resp.data })
            });
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        const { data } = this.props;
        const { news } = this.state;
        //console.log('NEWS AND LINKS:', data);

        return(
            <ModuleWrapper background={data.background}>
                <Container>
                    <Row>
                        <News>
                            <Title>{WP.trans.latestNews}</Title>
                            {news.filter((n,i) => i < 2).map(post => {
                                return (
                                    <NewsItem key={post.id}>
                                        <h5>{post.title.rendered}</h5>
                                        <p>{trunclate(post.acf.excerpt, 100, ' ...')}</p>
                                        <div>
                                            <span><DateFormater input={post.date} /></span>
                                            <SmartLink to={post.link} >{WP.trans.readMore}</SmartLink>
                                        </div>
                                    </NewsItem>
                                )
                            })}
                            {news.length > 2 &&
                                <NewsArchiveLink to={WP.post_page_slug}>{WP.trans.moreNews}</NewsArchiveLink>
                            }
                        </News>
                        <LinksOneCol>
                            <Title>{data.links_column_1_title}</Title>
                            <ul>
                                {data.links_column_1_links[0] &&
                                    data.links_column_1_links.map((item, i) => {
                                        return <li key={i}><SmartLink to={item.link.url} >{item.link.title}</SmartLink></li>
                                    })  
                                }
                            </ul>
                        </LinksOneCol>
                        {data.links_column_2_links[0] &&
                            <LinksTwoCol last>
                                <Title>{data.links_column_2_title}</Title>
                                <ul>
                                    {data.links_column_2_links.map((item, i) => {
                                        return <li key={i}><SmartLink to={item.link.url} >{item.link.title}</SmartLink></li>
                                    })}  
                                </ul>
                            </LinksTwoCol>
                        }
                    </Row>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default withRouter(NewsAndLinks);

const ModuleWrapper = styled.div`
    background-color: ${props => props.background === 'white' ? '#fff' : css.colors.gray};  
    padding: 130px 0;
    @media (max-width:768px) {
        padding: 50px 0;
    }
`

const Row = styled.div`
    display:flex;
    flex-wrap:wrap;
`

const News = styled.section`
    width:40%;
    padding-right: 12%;
    position:relative;
    @media (max-width:1080px) {
        width:100%;
        margin-bottom:50px;
    }
    article {
        &:last-child {
            margin-bottom: 0;
        }
    }
`

const Title = styled.h4`
    font-size:43px;
    line-height: 50px;
    margin-bottom: 40px;
    font-family: ${css.fonts.bg_bold};
    @media (max-width:1080px) {
        font-size:30px;
    }
    @media (max-width:480px) {
        margin-bottom: 20px;
    }
    @media (max-width:480px) {
        font-size: 26px;
        line-height: 31px;
    }
`

const NewsItem = styled.article`
    margin-bottom: 40px;
    h5 {
        font-size:22px;
        font-family: ${css.fonts.bg_medium};
    }
    p {
        font-size:18px;
        margin:12px 0;
    }
    div {
        span, a {
            font-sie:14px;
            color: #797979;
        }
        span {
            margin-right:30px;
        }
        a {
            border-bottom-color: #9e9e9e;
        }
    }
`

const NewsArchiveLink = styled(SmartLink)`
    font-size:18px;
`

const LinksOneCol = styled.section`
    width:25%;
    @media (max-width:1080px) {
        width:50%;
    }
    @media (max-width:480px) {
        width:100%;
        margin-bottom:60px;
    }
    li {
        margin-bottom:15px;
        &:last-child {
            margin-bottom:0;
        }
        a {
            font-size:18px;
        }
    }
`

const LinksTwoCol = styled.section`
    width:35%;
    @media (max-width:1080px) {
        width:50%;
    }
    @media (max-width:768px) {
        width:50%;
    }
    @media (max-width:480px) {
        width:100%;
        margin-bottom:60px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    ul {
        display:flex;
        position: relative;
        flex-wrap:wrap;
        li {
            width:100%;
            //margin-right:10%;
            margin-bottom:15px;
            &:last-child {
                margin-bottom:0;
            }
            a {
                font-size:18px;
            }
            @media (max-width:1080px) {
                width:100%;
                margin-right: 0;
            }
        }
    }
`




// WEBPACK FOOTER //
// ./src/partials/modules/NewsAndLinks.js